import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ApplicationType } from 'enums/ApplicationType';
import { ContractorNameSource } from 'enums/ApplicationsVariables';

export interface SalespersonInfo {
  name: string;
  email?: string;
  phone?: string;
}

export interface DataState {
  applicationType: ApplicationType | null;
  contractorName: string;
  salesPerson: string;
  salespersonData: Record<string, SalespersonInfo>;
  network: string | null;
  device: string | null;
  promoCode: string;
  refer: string | null;
  contractorPromoLinkUsed: boolean | null;
  howDidYouHearAboutUs: string | null;
  howDidYouHearAboutUsComment: string | null;
  isIframe?: boolean;
  contractorAutofillUsed?: ContractorNameSource | null;
  campaignId: string | null;
  adGroupId: string | null;
  utmSource: string | null;
  utmMedium: string | null;
  utmCampaign: string | null;
  utmTerm: string | null;
  utmContent: string | null;
  gclid: string | null;
  fbclid: string | null;
  liFatId: string | null;
  muId: string | null;
  uetMsclkId: string | null;
}

const initialState: DataState = {
  applicationType: null,
  contractorName: '',
  salesPerson: '',
  salespersonData: {},
  network: '',
  device: '',
  promoCode: '',
  refer: '',
  contractorPromoLinkUsed: null,
  howDidYouHearAboutUs: '',
  howDidYouHearAboutUsComment: '',
  isIframe: false,
  campaignId: '',
  adGroupId: '',
  utmSource: '',
  utmMedium: '',
  utmCampaign: '',
  utmTerm: '',
  utmContent: '',
  gclid: '',
  fbclid: '',
  liFatId: '',
  muId: '',
  uetMsclkId: '',
};

const data = createSlice({
  name: 'data',
  initialState,
  reducers: {
    setData: (state: DataState, { payload }: PayloadAction<Partial<DataState>>) => {
      Object.assign(state, payload);
    },
  },
});

export const { setData } = data.actions;

export default data.reducer;
